import styled, { AnyStyledComponent, css } from 'styled-components'
import { tabletBreakpoint } from 'react-components'
import CustomModal from '../../../common/modal'
import CloseIcon from '../../../../assets/icons/filter-icons/close-icon.svg'

export const Container = styled.div`
    position: relative;
`

export const Content = styled.div<{ isModal?: boolean; isSortOpen: boolean }>(
    ({ theme, isModal, isSortOpen }) => css`
        display: flex;
        flex-direction: column;
        padding-bottom: ${theme.spacing.medium};
        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            ${!isModal &&
            css`
                display: ${isSortOpen ? 'block' : 'none'};
                position: absolute;
                left: ${theme.spacing.medium};
                padding: ${theme.spacing.large} ${theme.spacing.xxLarge} ${theme.spacing.xSmall} ${theme.spacing.large};
                min-width: 23.125rem;
                top: 2.5rem;
                box-shadow: 0 8px 10px #0000000f, 0 3px 14px #0000000a, 0 5px 5px #00000014;
                border-radius: ${theme.typography.border.radius.small};
                margin-bottom: 0;
                background-color: ${theme.colors.white};
                z-index: 1000;
            `}

            ${isModal &&
            css`
                padding: ${theme.spacing.medium};
            `}
        }
    `,
)

export const DesktopTabletContainer = styled.div`
    position: relative;
    background-color: ${({ theme }) => theme.colors.white};
    display: none;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        display: block;
    }
`

interface HeaderProps {
    isActive?: boolean
    isSortSelected?: boolean
}

export const Header = styled.span<HeaderProps>(
    ({ isActive, isSortSelected, theme }) => css`
        display: flex;
        justify-content: space-between;
        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            display: inline-flex;
            flex-direction: row;
            justify-content: start;
            align-items: center;
            padding: 0.1875rem 0.4375rem 0.1875rem 0.6875rem;
            border: ${theme.typography.border.radius.xxxSmall} solid #2298da33;
            border-radius: ${theme.typography.border.radius.xxLarge};
            background-color: ${theme.colors.white};

            &:hover {
                border: ${theme.typography.border.radius.xxxSmall} solid #2298da80;
            }

            ${(isActive || isSortSelected) &&
            css`
                background: #2298da14;
                border: ${theme.typography.border.radius.xxxSmall} solid #2298da33;
            `}

            & + .sort-content {
                ${isActive &&
                css`
                    display: block;
                `}
            }
        }
    `,
)

export const LoaderContainer = styled.div<{ isLoading?: boolean }>`
    display: none;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    pointer-events: none;
    background-color: #21212180;

    ${props =>
        props.isLoading &&
        css`
            display: flex;
            justify-content: center;
            align-items: center;
        `}
`
export const MobileContainer = styled.div(
    ({ theme }) => css`
        display: flex;
        justify-content: center;
        align-items: center;
    `,
)

export const OuterContainer = styled.div<{ isLoading?: boolean }>`
    position: fixed;
    display: flex;
    flex-direction: column;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #2121214d;
    ${props =>
        props.isLoading &&
        css`
            pointer-events: none;
            cursor: progress;
        `}
`
export const Overlay = styled.div`
    flex-grow: 1;
`
export const SortCustomModal = styled(CustomModal)`
    & .Overlay {
        background: transparent;
    }
    & .Modal {
        display: flex;
        flex-direction: column;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 0;
        background: transparent;
    }
`
export const StyledCloseIcon = styled(CloseIcon as AnyStyledComponent)`
    width: 3.5rem;
    height: 3.25rem;
    padding: 1.125rem 0.785rem 0.625rem 1.125rem;
    cursor: pointer;
`

export const StyledMobileContainer = styled.div(
    ({ theme }) => css`
        position: fixed;
        display: flex;
        flex-direction: column;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: ${theme.colors.white};
        border-radius: ${theme.typography.border.radius.xLarge} ${theme.typography.border.radius.xLarge} 0 0;
        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            position: relative;
        }
    `,
)

export const MobileHeaderContainer = styled.div(
    ({ theme }) => css`
        height: 3.5rem;
        width: 100%;
        box-sizing: border-box;
        cursor: pointer;
        display: flex;
        border-bottom: ${theme.typography.border.width.xxxThin} solid #0000001a;
        justify-content: space-between;
        align-items: center;
    `,
)

export const MobileHeaderTitle = styled.strong(
    ({ theme }) => css`
        flex-grow: 1;
        padding: 0.875rem 0 0.875rem 1.5rem;
        letter-spacing: -0.021875rem;
        font: ${theme.typography.font.lato.weight.black} ${theme.typography.font.size.large} / 1.75rem
            ${theme.typography.font.family.latoVerdana};
    `,
)

export const MobileHeaderRight = styled.span(
    ({ theme }) => css`
        padding: ${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.medium} 0;
        text-align: right;
        color: ${theme.colors.tfwBlack99};
        cursor: pointer;
        font-weight: 400;
        font-size: 0.875rem;
        font-family: ${theme.typography.font.family.latoVerdana};
    `,
)

export const Title = styled.strong(
    ({ theme }) => css`
        flex-grow: 1;
        padding: ${theme.spacing.medium} 0 ${theme.spacing.small};
        font: ${theme.typography.font.lato.weight.black} ${theme.typography.font.size.medium} /
            ${theme.typography.font.size.xLarge} ${theme.typography.font.family.latoVerdana};
        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            padding: 0;
            user-select: none;
            max-width: 9.375rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-weight: ${theme.typography.font.lato.weight.regular};
            font-size: ${theme.typography.font.size.small};
        }
    `,
)
